import { render, staticRenderFns } from "./SectionSidebarItem.vue?vue&type=template&id=6ff3d1ca&"
import script from "./SectionSidebarItem.vue?vue&type=script&lang=js&"
export * from "./SectionSidebarItem.vue?vue&type=script&lang=js&"
import style0 from "./SectionSidebarItem.vue?vue&type=style&index=0&id=6ff3d1ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports